import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "label", "status" ]
  static values = {
    url: String,
    title: String,
    text: String,
    copiedLabel: { type: String, default: "Link copied" }
  }

  disconnect() {
    window.clearTimeout(this.resetTimer)
  }

  async share(event) {
    event.preventDefault()

    if (navigator.share) {
      try {
        await navigator.share({
          title: this.titleValue,
          text: this.textValue,
          url: this.urlValue
        })
        this.announce("Shared")
      } catch (error) {
        if (error.name !== "AbortError") this.announce("Unable to share this link")
      }
      return
    }

    try {
      await this.copyUrl()
      this.showCopiedState()
    } catch (_error) {
      this.announce("Unable to copy this link")
    }
  }

  async copyUrl() {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(this.urlValue)
      return
    }

    const input = document.createElement("textarea")
    input.value = this.urlValue
    input.setAttribute("readonly", "")
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.appendChild(input)
    input.select()

    const copied = document.execCommand("copy")
    input.remove()
    if (!copied) throw new Error("Copy command failed")
  }

  showCopiedState() {
    const originalLabel = this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedLabelValue
    this.announce(this.copiedLabelValue)

    window.clearTimeout(this.resetTimer)
    this.resetTimer = window.setTimeout(() => {
      this.labelTarget.textContent = originalLabel
    }, 2000)
  }

  announce(message) {
    this.statusTarget.textContent = message
  }
}
